import type { MouseEventHandler } from 'react';
import colours from '../../../colours';

interface Props {
    onClick?: MouseEventHandler<HTMLDivElement>;
}

export default function LoadingIndicatorFull({ onClick }: Props) {
    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div className={'state_loading state_loading--active'} onClick={onClick}>
            <svg viewBox="0 0 326.48 285.07" className="state_loading-logo">
                <defs>
                    <clipPath id="clippath">
                        <polygon
                            points="191.42 98.76 213.54 112.88 272.92 112.88 272.92 217.25 48.64 217.25 48.64 99.98 191.42 98.76"
                            style={{ fill: 'none' }}
                        />
                    </clipPath>
                </defs>
                <g>
                    <path
                        d="M167.34,285.07h-8.19C71.25,285.07,0,232.47,0,142.53h0C0,52.6,71.25,0,159.15,0h8.19c87.89,0,159.14,52.6,159.14,142.53h0c0,89.94-71.25,142.54-159.14,142.54Z"
                        style={{ fill: colours.SIYellow }}
                    />
                    <path
                        className="state_loading-logo-dot"
                        d="M214.67,92.07c-7.88,1.07-15.12-4.45-16.19-12.33s4.45-15.12,12.33-16.19c7.88-1.07,15.12,4.45,16.19,12.33,0,0,0,0,0,.01,1.04,7.87-4.47,15.1-12.33,16.18Z"
                    />
                </g>
                <g id="Layer_2" data-name="Layer 2">
                    <g style={{ clipPath: 'url(#clippath)' }}>
                        <path
                            className="state_loading-logo-path"
                            d="M62.59,167.28s22.1-14.97,35.37-26.26c13.27-11.29,30.63-27.88,36.42-34.73-8.47,17.69-8,26.54,9.88,43.67,31.45,30.13,12.29,59.33-7.72,56-17.51-2.92-19.29-23.44-9.93-35.81,6.17-8.16,43.53-47.86,76.85-64.71-4.52,16.19-17,68.39,11.01,76.52,18.82,5.46,36.03-19.81,42.7-30.78"
                            style={{
                                fill: 'none',
                                stroke: colours.SIBlack,
                                strokeLinejoin: 'bevel',
                                strokeWidth: '16px',
                            }}
                        />
                    </g>
                </g>
            </svg>
            <div className="state_loading-text">Loading…</div>
        </div>
    );
}
